<template>
  <div>
    <stacked-bar-chart
      v-if="healthData.id"
      :key="healthData.id"
      :graphdata="healthData"
      :legend="false"
      :total="total"
      :only-percent="true"
    />
  </div>
</template>
<script>
import store from '@/store/index'
import { defineComponent, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import StackedBarChart from '@core/components/charts/echart/StackedBarChart.vue'

export default defineComponent({
  components: {
    StackedBarChart,
  },
  props: {
    lineAssets: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const toast = useToast()
    const healthData = ref({ labels: [], data: [] })
    const total = ref(0)
    const now = new Date()
    const endTime = Date.now()
    const startTime = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).getTime()
    const fetchAssets = () => {
      const filteredData = props.lineAssets.filter(item => item.name === 'Main Drive Motor 1')
      const asset = filteredData[0]
      store
        .dispatch('app-asset-main/fetchGraph', { assetID: asset.assetID, type: 'availability' })
        .then(response => {
          const { data } = response
          total.value = endTime - startTime
          healthData.value = data
        })
        .catch(e => {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data from server',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    fetchAssets()

    return {
      healthData,
      total,
    }
  },
})
</script>
